module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedThin.b12e793.woff2";